// extracted by mini-css-extract-plugin
export default {"skillsSection":"Skills_skillsSection__7sPbp","heading":"Skills_heading__Ahk1V","list":"Skills_list__wH-aZ","pill":"Skills_pill__kf7xr"};